<div style="padding: 20px;">
    <mat-card-content>
        <mat-tab-group style="height: 400px;">
            <mat-tab label="Send Email" style="padding: 10px;">
                <div class="separator"></div>
                <div class="label-style">Send Email to</div>
                <div>
                    <textarea class="col-input" rows="2" style="margin: 1px; resize: none;" placeholder="Type name" readonly>{{emailAdresses}}</textarea>
                </div>
                <div class="separator"></div>
                <div class="label-style" fxFlex="10">Object</div>
                <div style="max-width: 50vw;">
                    <input type="text" class="col-input" style="margin: 1px;" placeholder="Type name" [formControl]="emailObjectControl">
                </div>
                <div class="separator"></div>
                <div class="label-style" fxFlex="10">Content</div>
                <div>
                    <textarea class="col-input" rows="4" style="margin: 1px; resize: none;" placeholder="Message (sans salutation)..." [formControl]="emailContentControl"></textarea>
                </div>
                <div class="modal-footer" style="margin-top: 5px;">
                    <button type="button" class="button-secondary-small left-side" (click)="close()">Close</button>
                    <button type="button" class="button-validate-small" (click)="sendEmail()">Send EMAIL</button>
                </div>
            </mat-tab>
            <mat-tab label="Send Notification" style="padding: 10px;">
                <div class="separator"></div>
                <div class="label-style">Send Notification to</div>
                <div>
                    <textarea class="col-input" rows="2" style="margin: 1px; resize: none;" placeholder="Type name" readonly>{{notificationPseudo}}</textarea>
                </div>
                <div class="separator"></div>
                <div class="label-style" fxFlex="10">Object</div>
                <div style="max-width: 50vw;">
                    <input type="text" class="col-input" style="margin: 1px;" placeholder="Type name" [formControl]="notificationObjectControl">
                </div>
                <div class="separator"></div>
                <div class="label-style" fxFlex="10">Content</div>
                <div>
                    <textarea class="col-input" rows="4" style="margin: 1px; resize: none;" placeholder="Message (sans salutation)..." [formControl]="notificationContentControl"></textarea>
                </div>
                <div class="modal-footer" style="margin-top: 5px;">
                    <button type="button" class="button-secondary-small left-side" (click)="close()">Close</button>
                    <button type="button" class="button-validate-small" (click)="sendNotification()">Send Notification</button>
                </div>
            </mat-tab>
            <mat-tab label="Send SMS" class="mat-tab-style">
                <div class="separator"></div>
                <div class="label-style">Send SMS to</div>
                <div>
                    <textarea class="col-input" rows="2" style="margin: 1px; resize: none;" placeholder="Type name" readonly>{{phoneNumbers}}</textarea>
                </div>
                <div class="separator"></div>
                <div class="label-style" fxFlex="10">Content</div>
                <div>
                    <textarea class="col-input" rows="3" style="margin: 1px; resize: none;" maxlength="100" placeholder="Message (sans salutation)..." [formControl]="smsContentControl"></textarea>
                </div>
                <div class="modal-footer" style="margin-top: 5px;">
                    <button type="button" class="button-secondary-small left-side" (click)="close()">Close</button>
                    <button type="button" class="button-validate-small" (click)="sendSMS()">Send SMS</button>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</div>

